import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../lib/auth.js';
import type { Me } from '../lib/auth.js';

// The signed-in person, from GET /api/me (the current portal read /.auth/me). Every page sits
// inside RequireUser, so this is loaded before any page renders; `undefined` only while it loads.
export const CURRENT_USER_KEY = ['auth-me'] as const;

export function useCurrentUser(): Me | undefined {
  const { data } = useQuery({
    queryKey: CURRENT_USER_KEY,
    queryFn: fetchMe,
    staleTime: Infinity,
  });
  return data ?? undefined;
}
